import { Button } from '@virtidev/toolbox';
import styled, { css } from 'styled-components';

export const OverlayButtonWrapper = styled.div`
  position: relative;
`;

export const OverlayNameWrapper = styled.div`
  position: absolute;
  width: 138px;
  height: 39px;
  display: none;
  ${(props) =>
    props.$location === 'right' &&
    css`
      left: 0;
    `}
  ${(props) =>
    props.$location === 'left' &&
    css`
      right: 0;
    `}
  ${(props) =>
    props.$location === 'bottom' &&
    css`
      top: initial;
      transform: translate(-50%, 0);
      left: 50%;
      bottom: -40px;
    `}
`;

export const OverlayName = styled.div`
  position: absolute;
  ${(props) =>
    props.$location === 'right' &&
    css`
      left: 3rem;
    `}
  ${(props) =>
    props.$location === 'left' &&
    css`
      right: 3rem;
    `}
  top: 0.4rem;
  transform: translateX(-50%);
  left: 50%;
  background: ${(props) => props.theme.color.primary};
  color: ${(props) => props.theme.color.contrast.primary};
  padding: 0.1rem 0.5rem;
  border-radius: 8px;
`;

export const OverlayButton = styled(Button)`
  border-radius: 60px;
  width: 38px;
  height: 38px;
  padding: 0;
  ${(props) =>
    !props.$expanded &&
    css`
      background-color: ${(props) => props.theme.color.darkGrey};
    `}
  :hover ${OverlayNameWrapper} {
    display: block;
  }
`;

OverlayButton.displayName = 'OverlayButton';
